import { render, staticRenderFns } from "./SupportBoxDetail.vue?vue&type=template&id=1893bf6c"
import script from "./SupportBoxDetail.vue?vue&type=script&lang=js"
export * from "./SupportBoxDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports